/**
 * Aderência de categoria/subcategoria do insumo à coleção Categorias_Insumos.
 */

export function normalizarChaveCategoria(valor) {
  if (!valor || typeof valor !== 'string') return '';
  return valor
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

/** Agrupa documentos por nome de categoria e une subcategorias (sem duplicar). */
export function mergeCategoriasPorNome(rows) {
  const map = new Map();
  for (const row of rows || []) {
    const key = String(row.categoria || '').trim();
    if (!key) continue;
    const subsIn = Array.isArray(row.subcategorias) ? row.subcategorias : [];
    if (!map.has(key)) {
      map.set(key, {
        categoria: key,
        subcategorias: subsIn.map((s) => String(s).trim()).filter(Boolean),
      });
    } else {
      const prev = map.get(key);
      const set = new Set([
        ...prev.subcategorias,
        ...subsIn.map((s) => String(s).trim()).filter(Boolean),
      ]);
      prev.subcategorias = [...set];
    }
  }
  return [...map.values()].sort((a, b) =>
    a.categoria.localeCompare(b.categoria, 'pt-BR', { sensitivity: 'base' })
  );
}

/** Mapa chave normalizada da categoria → { categoria, subcategorias: Set(chaves) } */
export function buildCatalogoMapFromRows(rows) {
  const merged = mergeCategoriasPorNome(rows);
  const map = new Map();
  for (const row of merged) {
    const key = normalizarChaveCategoria(row.categoria);
    if (!key) continue;
    map.set(key, {
      categoria: row.categoria,
      subcategorias: new Set(
        (row.subcategorias || []).map((s) => normalizarChaveCategoria(s)).filter(Boolean)
      ),
    });
  }
  return map;
}

/**
 * @returns {{ aderente: boolean, motivos: string[], catalogoVazio?: boolean }}
 */
export function avaliarAderenciaCategorias(produto, catalogoMap) {
  if (!catalogoMap || catalogoMap.size === 0) {
    return { aderente: true, motivos: [], catalogoVazio: true };
  }

  const catRaw = String(produto?.categoria || '').trim();
  if (!catRaw) {
    return { aderente: false, motivos: ['sem_categoria'] };
  }

  const row = catalogoMap.get(normalizarChaveCategoria(catRaw));
  if (!row) {
    return { aderente: false, motivos: ['categoria_nao_parametrizada'] };
  }

  const subRaw = String(produto?.subcategoria || '').trim();
  if (subRaw) {
    const subKey = normalizarChaveCategoria(subRaw);
    if (!row.subcategorias.has(subKey)) {
      return { aderente: false, motivos: ['subcategoria_nao_parametrizada'] };
    }
  }

  return { aderente: true, motivos: [] };
}

const ROTULOS_MOTIVO = {
  sem_categoria: 'Sem categoria',
  categoria_nao_parametrizada: 'Categoria fora do padrão',
  subcategoria_nao_parametrizada: 'Subcategoria fora do padrão',
};

export function rotuloMotivosAderencia(motivos) {
  if (!motivos?.length) return '';
  return motivos.map((m) => ROTULOS_MOTIVO[m] || m).join(' · ');
}
